export default {
    title: 'Constanta Casino - online tickets',
    search: 'Search',
    all_states: 'All States',
    all_museums: 'Our museums',
    homepage_title: "Visit Constanța Casino",
    homepage_desc: "An enduring symbol of elegance on the Black Sea coast",
    cart: 'Cart',
    no_tickets: 'No tickets',
    checkout: 'Checkout',
    ticket: 'ticket',
    next_step: 'Next',
    select_tickets: 'Select tickets',
    read_more: 'Show more',
    read_less: 'Show less',
    museums: 'Museums',
    login: 'Login',
    my_account: 'My account',
    register: 'Register',
    create_account: 'Create account',
    create_account_desc:'for easy access to your purchases history',
    continue_as_guest: 'Continue as guest',
    email: 'Email',
    email_address: 'Email',
    phone: 'Phone',
    firstName: 'Firstname',
    lastName: 'Lastname',
    password: 'Password',
    confirm_password: 'Confirm password',
    accept_newsletter: 'I want to subscribe to the newsletter',
    send_sms: 'Also receive tickets via sms',
    terms_conditions: 'terms and conditions',
    authentication: 'Authentication',
    use_form_below: 'Use the form below to log in and access your tickets',
    forgot_password: 'I forgot my password',
    new_account: 'New Account',
    new_user: 'New client',
    enter_email_to_reset_password: 'Enter the email address of the account to reset the password',
    reset_password_button: 'Reset password',
    follow_email_instructions: 'Follow the instructions sent to your email to reset your password.',
    terms_and_conditions: 'Terms and Conditions',
    response_payment: 'Payment response',
    payment_confirmed_congratulations: 'Payment has been confirmed. Congratulations!',
    open_e_ticket: 'Open E-TICKET',
    order_not_confirmed_error_message: 'Order could not be confirmed. Error message:',
    please_try_again_to_purchase_tickets: 'Please try again to purchase tickets.',
    please_pay_again_tickets: 'Please try again to make the payment. Your tickets are on hold until',
    museum_list: 'List of museums',
    back: 'Back',
    orders: 'Orders',
    personal_info: 'Personal information',
    change_password: 'Change password',
    exit: 'Exit',
    no_orders: 'No orders',
    save: 'Save',
    current_password: 'Current password',
    new_password: 'New password',
    delete: 'Delete',
    tickets_total: 'Tickes total',
    tax: 'Processing fees',
    total_payment: 'To pay',
    pay: 'Go to payment',
    pay_again: 'Pay again',
    continue_shopping: 'Select more tickets',
    tickets_email: 'We will send the tickets to this email address',
    modify: 'Modify',
    my_cart: 'My tickets',
    user_details: 'Client details',
    payment: 'Payment',
    terms: 'Terms and conditions',
    gdpr: 'GDPR terms',
    last_tickets: 'Last tickets',
    sold_out: 'Sold Out',
    pick_tickets: 'Choose tickets',
    not_found_order: 'Order not found',
    expiration_date: 'Expiration date',
    open_eticket: 'Open E-TICKET',
    payment_method: 'Payment',
    delivery_method: 'Delivery',
    show_details: 'show details',
    hide_details: 'hide details',
    Confirmat: 'Confirmed',
    Neconfirmat: 'Pending',
    Anulat: 'Canceled',
    tickets: 'Tickets',
    my_order: 'My order',
    what_to_visit: 'Our Attractions',
    Adult: 'Adult',
    Elev: 'School child',
    Student: 'Student',
    Pensionar: 'Senior',
    'Castelul Peleș (expoziția de bază)': 'Peleș Castle (1st floor)',
    'Castelul Peleș (tur opțional 1)': 'Peleș Castle (1st and 2nd floor)',
    'Castelul Pelișor': 'Pelișor Castle',
    'Castelul Peleș': 'Peleș Castle',
    go_to_schedule: 'Check Visiting Schedule',
    faqs: 'Intrebari frecvente',
    faqs_q_1: 'Cine beneficiază de gratuitate la vizitarea Muzeului Național Peleș?',
    faqs_a_1: 'Beneficiază de gratuitate la biletele de intrare în muzee, pe baza documentelor justificative:<li>Copii preșcolari (până în vârsta de 7 ani);</li><li>Copiii în vârstă de până la 18 ani, pe perioada vacanțelor;</li><li>Elevii și studenții cetățeni români din afara granițelor țării, bursieri ai statului român;</li><li>Copiii în vârstă de până la 18 ani, care au nevoi speciale sau cu handicap , precum și pentru persoana însoțitoare a copilului în vârstă de până la 18 ani cu handicap;</li><li>Copii în vârstă de până la 18 ani cărora li se aplică măsuri sociale de protecție;</li><li>Adulți cu handicap grav sau accentuat, precum și persoana care îi însoțește;</li><li>Posesorii de carduri Euro 26, cu vârsta de până la 30 ani, în fiecare zi de 26 din fiecare lună, atunci când aceasta cade într-o zi când instituția este deschisă pentru public; dacă 26 cade într-o zi când instituția este închisă pentru public, atunci gratuitatea se acordă în ziua lucrătoare imediat următoare a lunii;</li><li>Pensionarii din rețeaua muzeală, posesori de adeverințe/legitimații pentru acces gratuit;</li><li>Posesorii cardurilor ICOM;</li><li>Cadrul didactic însoțitor, la un numar de 20 de elevi vizitatori, la vizitarea expoziției de bază a castelului Peleș și a castelului Pelișor. Pentru vizitarea tururilor opționale, la un număr de 20 de elevi vizitatori, un cadru didactic însoțitor beneficiază de reducere de 75% din tariful pentru vizitatori adulți;</li><li>Pensionarii, în data de 1 octombrie, atunci când se sărbătorește Ziua Internațională a Persoanelor Vârstnice;</li><li>Delegațiile oficiale, precum și pentru alte delegații cu caracter cultural, în limita programului de funcționare al muzeului;</li><li>Angajații rețelei muzeale, ai Ministerului Culturii și ai serviciilor deconcentrate ale Ministerului Culturii;</li><li>Angajații Institutului Național de Cercetare în Domeniul Conservării și Restaurării;</li><li>Reprezentanți mass-media;</li><li>Adulții cu handicap mediu și ușor beneficiază de reducere 75% din tariful perceput adulților pentru accesul la muzeele aflate în subordinea Ministerului Culturii.</li><br/>Mai multe detalii <a href="https://peles.ro/ro/program-si-taxe/" target="new" style="color: red;">aici</a>.',
    faqs_q_2: 'Cum pot cere rambursarea biletelor achiziționate online?',
    faqs_a_2: 'În cazul în care biletele tale sunt eligibile pentru a fi rambursate, poți cere rambursarea trimițând un email la adresa contact[at]peles.ro',
    faqs_q_3: 'Cum pot primi factura fiscală pentru biletele comandate online?',
    faqs_a_3: 'Pentru a solicita factura fiscală pentru comanda plasată pe bilete.peles.ro completează <a href="/factura" style="color: red;">formularul de solicitare</a> a facturii fiscale. Factura fiscală va fi emisă după efectuarea vizitei la muzeu.',
    easter_schedule: 'Easter Holidays Schedule',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    tickets_desk_close: 'The ticket desk closes at 13:00.',
    closed: 'CLOSED',
    last_enter: 'last entry',
    last_enter_optional: 'last entry optional tour 12:30',
    school_children: 'School children benefit from free admission during school holidays.',
    under7: 'Children up to 7 years old – free of charge.',
    refund_policy: 'Return Policy',
    refund_detail_1: 'Online tickets purchased on www.bilete.peles.ro are valid for 14 days. If the 14-day period has been exceeded without using the ticket, the value of the ticket is not refunded.',
    refund_detail_2: 'If the online ticket was validated by scanning the QR code upon entering the museum, the ticket is considered used and cannot be refunded.',
    refund_detail_3: 'According to GEO 34/2014, if you are a consumer (natural person) you have the right to withdraw from the contract, without any specific reason, within 14 days from the day on which you or a third party authorized by you, came into possession of the tickets. Thus, you can send the withdrawal request by filling in the <a href="/refund" style="color: red;">ticket refund request</a>.',
    refund_detail_4: 'After returning the value of the ticket purchased online, it will be invalidated and can no longer be used.',
    refund_detail_5: 'In case of refunds, the price printed on the ticket will be refunded in full. A partial price cannot be claimed for refund. The customer assumes full responsibility for the complete realization of the optional tours. A partial refund of a ticket cannot be requested if the customer has decided not to complete the tour for which he purchased an electronic ticket. The ticket value will be refunded to the valid account from which the initial payment was made.',
    refund_detail_6: 'In the event of cancellation, postponement or major schedule changes, no other related expenses (transportation, accommodation, delivery charges or other charges) will be refunded. The Peleș National Museum will be able to refund, in case of cancellation of the order, only the price of the ticket written on it.',
    refund_title: 'Ticket refund request',
    refund_aggree: 'I consent to Peleș National Museum using the personal information provided in this form (name and surname, e-mail address, bank account information), in accordance with EU Regulation 2016/679 - Protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) and other applicable legislation, with the purpose of processing the refund request.',
    ticket_identificator: 'Ticket series/order ID/Date of purchase',
    refund_info: 'The money will be refunded to the account from which you made the payment. The cost of the tickets will be refunded, but not the transaction processing fee.',
    refund_bank_details: 'Bank account information (name, surname, bank, IBAN code)',
    refund_reason: 'Reason you want a refund',
    refund_request_ok: 'Your refund request was succesfully sent.',
    refund_request_error: 'There was an error in sending your request. Please verify the order number',
    contact_technical: 'Technical ticketing info',
    contact_museum: 'Info about visiting the museum',
    confirm_hour_add_title: 'Atention!',
    confirm_hour_add_msg: 'The castle is closed for today!',
    add_to_cart: 'Add to cart',
    mandatory_field: 'This field is mandatory.',
    wrong_email: 'Invalid email format.',
    password_mismatch: 'Password mismatch.',
    terms_mandatory: 'Please accept terms and conditions.',
    phone_invalid: 'Phone number is not valid.',
    access_interval: 'Entrance hours',
    hour: 'Hour',
    info_fewer_tickets: 'Fewer tickets were selected than wanted',
    could_not_select_all: 'Fewer tickets selected',
    info_no_tickets: 'There are no more tickets available',
    could_not_select: 'Error selecting tickets',
    access_interval_date: 'Between',
    date: 'Date',
    pick_hour: 'Select hour',
    select_date: 'Select date',
    sector: 'sector',
    section: 'section',
    row: 'row',
    seat: 'seat',
    youveSelected: 'You have selected',
    ticketSingular: 'ticket',
    ticketPlural: 'tickets',
    automatic_selection: 'Select best seats',
    manual_selection: 'Choose from seat map',
    selectFail: 'Could not select ticket',
    apply_voucher: 'Apply voucher',
    voucher_code: 'Voucher code',
    invalid_voucher: 'Invalid voucher code',
    voucher_applied: 'Voucher applied successfully',
    price_legend: 'Price legend',
    invoice: 'Invoice',
    invoice_info: 'If you want an invoice for your order on billete.peles.ro, please fill out the form below carefully.',
    transaction_id: 'Order number',
    visit_date: 'Date of visit',
    full_name: 'Full name',
    company_name: 'Company',
    cui: 'Tax ID number',
    reg_com: 'Business register number',
    address: 'Registered office/Address',
    bank: 'Bank',
    iban: 'Account (IBAN)',
    invoice_type: 'Invoice type',
    country: 'Country',
    company_representative: 'Company representative',
    company: 'Company',
    individual: 'Individual',
    barcode: 'Barcode of a ticket',
    barcode_invoice_info: 'for prooving the ownership of the order',
    email_address_invoice_info: 'email address for sending the invoice',
    invoice_aggree: 'I consent to Peleș National Museum using the personal information provided in this form (name and surname, e-mail address, bank account information), in accordance with EU Regulation 2016/679 - Protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) and other applicable legislation, with the purpose of issuing the invoice.',
    invoice_send: 'Send',
    invoice_request_ok: 'Your invoice request has been succesfully sent.',
    invoice_generated_ok: 'Your invoice was successfully generated and sent to the email address provided.',
    invoice_request_error: 'Your invoice request could not be sent. Please verify the order number and the barcode.',
    invoice_already_printed: 'Invoice already generated',
    invalid_cui: 'Invalid Tax ID number',
    cookie_banner_text: 'This website uses cookies to analyze traffic and improve your browsing experience.',
    cookie_learn_more: 'Learn more',
    cookie_accept: 'Accept all',
    cookie_decline: 'Refuse optional'
}